export default {
    errors: {
        token_invalid: 'Invitation token is not valid',
        invitation_unkown_or_used: 'Invitation is already used or invalid',
    },
    buttons: {
        signup: 'Sign Up',
        continue_with_google: 'Continue with Google',
        continue_with_apple: 'Continue with Apple',
        continue_with_facebook: 'Continue with Facebook',
    },
    fields: {
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
        first_name: {
            label: 'First name',
            placeholder: 'John',
        },
        last_name: {
            label: 'Last name',
            placeholder: 'Smith',
        },
        password: {
            label: 'Password',
            placeholder: '6 characters minimum',
        },
        password_repeat: {
            label: 'Password Repeat',
            placeholder: 'Type your password again',
        },
    },
    passwords_not_match: 'Passwords do not match',
    please_register: 'Please login to continue!',
    no_account: 'No account?',
    agrement: `I agree to`,
    terms: 'Terms and conditions of use',
}
